import { bootstrapSiteConfig } from './lib/site-config/bootstrapSite';

// Fetch the site configuration from the API before loading the React app.
// This is necessary because modules like `src/utils/constants.ts` evaluate
// window variables immediately upon import. If we fetch this inside a React
// component (like Page.tsx), the constants would have already been evaluated
// with undefined values.
(async () => {
  try {
    await bootstrapSiteConfig();

    // Dynamically import the rest of the application.
    // This ensures that all module imports (and their top-level constant evaluations)
    // happen AFTER window is populated with the API data.
    const { bootstrapReactApp } = await import('./bootstrapReactApp');
    bootstrapReactApp();
  } catch (error) {
    console.error('Failed to initialize site configuration:', error);
  }
})();
